export const dialog = ({ ui }) => ui.dialog;
export const snackbar = ({ ui }) => ui.snackbar;
